import {v3} from "oc-threejs/short3";
import Scenes from "oc-threejs/Scenes";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import BaseType from "./BaseType";

export default class Raum extends BaseType(THREE.Group) {

    vsUpdate() {
        if (this.isVsChanged('size')) {
            Scenes.empty(this);
            this.createRoom();
        }
    }

    createRoom() {
        const breite = this.vsData.size.x;
        const hoehe = this.vsData.size.y;
        const tiefe = this.vsData.size.z;

        let wandMaterial, bodenMaterial;
        if (APP.settings.getBool('textureAtWallAndFloor')) {
            const bodenTextureMap = APP.model.loadTexture(APP.contentBaseUrl + 'textures/floor_map.jpg', 4, 4);
            bodenTextureMap.wrapS=bodenTextureMap.wrapT=THREE.MirroredRepeatWraping;
            const wallTextureMap = APP.model.loadTexture(APP.contentBaseUrl + 'textures/wall_map.jpg', 350, 300);
            bodenMaterial = new THREE.MeshPhongMaterial({
                map: bodenTextureMap,
                color: APP.settings.getInt('raum_boden_farbe'),
                side: THREE.BackSide
            });
          wandMaterial = new THREE.MeshPhongMaterial({
                color: APP.settings.getInt('raum_wand_farbe'),
                side: THREE.BackSide
            });
        } else {
            bodenMaterial = new THREE.MeshPhongMaterial({
                color: APP.settings.getInt('raum_boden_farbe'),
                side: THREE.BackSide
            });
            wandMaterial = new THREE.MeshPhongMaterial({
                color: APP.settings.getInt('raum_wand_farbe'),
                side: THREE.BackSide
            });
        }

        const deckeMaterial = new THREE.MeshPhongMaterial({
            color: APP.settings.getInt('raum_decke_farbe'),
            side: THREE.BackSide
        });
        const materials = [wandMaterial, wandMaterial, deckeMaterial, bodenMaterial, wandMaterial, wandMaterial];

        const wallsAndFloor = new THREE.Mesh(
            new THREE.BoxGeometry(breite, hoehe, tiefe),
            materials
        );
        wallsAndFloor.receiveShadow = true;
        wallsAndFloor.name = "Raum";
        wallsAndFloor.position.copy(v3(breite, hoehe, tiefe).multiplyScalar(0.5).setX(0)).add(v3(0, -0.1, 0));
        this.add(wallsAndFloor);

        // wallsAndFloor.visible = !APP.settings.localDevelopmentMode;

        if (APP.settings.getBool('fussleiste')) {
            // funktioniert nicht mit overSize
            const fl = {
                dicke: APP.settings.getMinValue('fussleiste_dicke'),
                hoehe: APP.settings.getMinValue('fussleiste_hoehe'),
                material: new THREE.MeshPhongMaterial({
                    color: APP.settings.getValue('fussleiste_material'),
                    side: THREE.DoubleSide
                }),
            };

            const box = (sx, sy, sz, px, py, pz, material) => {
                const b = Scenes.box(v3(sx, sy, sz), material);
                b.position.set(px, py, pz);
                return b;
            }

            this.add(box(fl.dicke, fl.hoehe, tiefe, -breite / 2 + fl.dicke / 2, fl.hoehe / 2, tiefe / 2, fl.material));
            this.add(box(fl.dicke, fl.hoehe, tiefe, breite / 2 - fl.dicke / 2, fl.hoehe / 2, tiefe / 2, fl.material));
            this.add(box(breite, fl.hoehe, fl.dicke, 0, fl.hoehe / 2, fl.dicke / 2, fl.material));
        }

        this.createCubeMap();
    }

    createCubeMap() {
        if (APP.settings.getBool('show_environment')) {
            let texture_root = APP.contentBaseUrl + '/textures/room01/';
            texture_root = texture_root.replace('http:', '');
            const texture_extension = 'png';
            this.envmap = UniversalLoader.loadTextureCube([
                texture_root + 'pos-x.' + texture_extension,
                texture_root + 'neg-x.' + texture_extension,
                texture_root + 'pos-y.' + texture_extension,
                texture_root + 'neg-y.' + texture_extension,
                texture_root + 'pos-z.' + texture_extension,
                texture_root + 'neg-z.' + texture_extension,
            ]);
        }
    }

}
